/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Grid, Tab, Tabs, styled } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useQlik } from "../../context/Qlik";
import KpiCard from "../../components/KpiCard/KpiCard";
import ChartSkeleton from "../../components/Skeletons/ChartSkeleton";
import FilterMessage from "../../components/FilterMessage/FilterMessage";
import ObjectLoader from "../../components/ObjectLoader/ObjectLoader";
import { useSelections } from "../../context/Selections";

const LayoutCardsWrapper = styled("div")({
	alignItems: "center",
	display: "flex",
	flexDirection: "column",
	height: "100%",
	justifyContent: "space-evenly",
	width: "100%",
});

const LayoutCardWrapper = styled("div")({
	borderRadius: "16px",
	display: "flex",
	width: "100%",
	paddingRight: "10px",
});

function OverviewMobile({ app, config, needFilter }) {
	const { selections } = useSelections();
	const [filterUpdate, sendFilterUpdate] = useState(0);
	const [showFullCard, setPosCard] = useState(true);
	const [loadingCard, setLoadingCard] = useState(true);
	const { setSwitchOnDemand } = useQlik();
	const tabList = ["Sell Out", "Sell In", "Positivação"];
	const [alignment, setAlignment] = useState("Sell Out");
	const alignmentTitle = {
		"Sell Out": "Sell Out em R$",
		"Sell In": "Sell In em R$",
		Positivação: "Positivação",
	};

	const initializeField = () => {
		app.field("%Selecao").selectMatch("Sell Out");
		setLoadingCard(false);
	};
	const checkPosCardState = (selections) => {
		if (selections.length) {
			const [analysisField, monthYearField] = [
				selections.find((s) => s.qField === "%Selecao"),
				selections.find((s) => s.qField === "Mês/Ano"),
			];

			const selectedAnalysis = analysisField?.qSelectedCount === 1;
			const selectedMonthYear = monthYearField?.qSelectedCount === 1;

			setPosCard(
				analysisField?.qSelected !== "Positivação" ||
					(selectedAnalysis && selectedMonthYear)
			);
		}
	};

	useEffect(() => {
		if (app) {
			initializeField();
		}
		setSwitchOnDemand(false);
	}, []);

	useEffect(() => {
		checkPosCardState(selections);
	}, [selections]);

	const handleChange = (event, newAlignment) => {
		app.field("%Selecao").selectMatch(tabList[newAlignment]);
		setAlignment(tabList[newAlignment]);
		sendFilterUpdate(newAlignment);
	};

	useEffect(() => {
		setSwitchOnDemand(false);
	}, []);

	return (
		<div className="app overview">
			<div className="appContent">
				<LayoutCardsWrapper>
					<LayoutCardWrapper>
						<Grid
							className="title-wrapper"
							container
							direction="row"
							justifyContent={"center"}
							alignItems={"center"}
						>
							<Box
								className="toggle"
								style={{
									margin: "0px 2px 4px",
									paddingBottom: "8px",
								}}
								color="primary"
							>
								<Tabs
									centered
									variant="fullWidth"
									value={filterUpdate}
									onChange={handleChange}
									aria-label="basic tabs example"
									style={{
										marginTop: "0px",
										paddingTop: "0px",
										textAlign: "center",
									}}
								>
									<Tab
										label={
											<span
												className="toggle-button"
												style={{ paddingLeft: "9px" }}
											>
												Sell Out
											</span>
										}
									/>
									<Tab
										label={
											<span
												className="toggle-button"
												style={{ paddingLeft: "18px" }}
											>
												Sell In
											</span>
										}
									/>
									<Tab
										label={
											<span className="toggle-button">
												Positivação
											</span>
										}
									/>
								</Tabs>
							</Box>
						</Grid>
					</LayoutCardWrapper>
					<Grid container>
						<Grid item xs={12}>
							<LayoutCardWrapper>
								<Grid
									container
									direction="row"
									justifyContent={"space-between"}
									alignItems={"center"}
									columnSpacing={2}
									style={{
										width: "100%",
									}}
								>
									<Grid item xs={12}>
										<KpiCard
											key={alignment}
											app={app}
											KPITitle={alignmentTitle[alignment]}
											valueId={
												alignment === "Positivação"
													? "08b43dc9-b873-442a-99e9-3cdeb714ba0d"
													: "571a7679-ddd4-4eb6-bb91-1bcf0f8b889d"
											}
											goalValueId={
												alignment === "Positivação"
													? "NFPqSSM"
													: "dkjxRE"
											}
											percentageId={"aSuuv"}
											hasProgressBar={true}
											fullView={showFullCard}
										></KpiCard>
									</Grid>
									<Grid item xs={12}>
										<KpiCard
											key={"MTD Y"}
											app={app}
											KPITitle={"MTD Y"}
											tooltipText={
												"Comparativo: Mês Atual x Mês Anterior do Mesmo Ano"
											}
											valueId={"RrHwwm"}
											valueDateId={"vNvmsU"}
											goalValueId={"RbvK"}
											goalDateId={"UpJQAn"}
											percentageId={"GmBCDa"}
											fullView
											></KpiCard>
									</Grid>
									<Grid item xs={12}>
										<KpiCard
											key={"MTD Y-1"}
											app={app}
											KPITitle={"MTD Y-1"}
											tooltipText={
												"Comparativo: Mês Atual x Mesmo Mês do Ano Anterior"
												}
												valueId={"sEDuqa"}
												valueDateId={"RNfJYF"}
												goalValueId={"MBzXPjP"}
												goalDateId={"NpyJ"}
												percentageId={"GuSPHXj"}
											fullView
										></KpiCard>
									</Grid>
									<Grid item xs={12}>
										<KpiCard
											key={"YTD"}
											app={app}
											KPITitle={"YTD"}
											tooltipText={
												"Comparativo: Ano Atual x Mesmo Período do Ano Anterior"
											}
											valueId={"mxqJu"}
											valueDateId={"meYpLp"}
											goalValueId={"pJUX"}
											goalDateId={"cjEst"}
											percentageId={"etkUv"}
											fullView
										></KpiCard>
									</Grid>
								</Grid>
							</LayoutCardWrapper>
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12}>
							<LayoutCardWrapper>
								<Grid
									item
									container
									direction="row"
									justifyContent={"space-between"}
									alignItems={"center"}
									columnSpacing={2}
									style={{
										width: "100%",
										display: "flex",
									}}
								>
									<Grid item xs={12}>
										<Card
											header={{
												hardTitle: "Acumulado",
											}}
											style={{
												width: "100%",
												minHeight: "250px",
												height: "30vh",
											}}
										>
											{loadingCard ? (
												<ObjectLoader
													icon="circle"
													width={"100%"}
													height={"100%"}
													scale={"2"}
												/>
											) : showFullCard ? (
												<NativeObject
													app={app}
													key="DYpApF"
													reference={{ id: "DYpApF" }}
												/>
											) : (
												<ChartSkeleton>
													<FilterMessage
														message="Selecione somente 1 Ano e Mes para análise com Meta de Positivação"
														absolute
													/>
												</ChartSkeleton>
											)}
										</Card>
									</Grid>
									<Grid item xs={12}>
										<Card
											header={{
												hardTitle: "Distribuidor",
												legends: showFullCard
													? [
															{
																type: "bar",
																iconColor:
																	"#F98561",
																name: "Meta",
															},
															{
																type: "bar",
																iconColor:
																	"#55B6EB",
																name: "Realizado",
															},
													  ]
													: [
															{
																type: "bar",
																iconColor:
																	"#55B6EB",
																name: "Realizado",
															},
													  ],
												scale: true,
											}}
											style={{
												width: "100%",
												minHeight: "250px",
												height: "30vh",
											}}
										>
											<NativeObject
												app={app}
												key="YUMfX"
												reference={{ id: "YUMfX" }}
												style={{
													maxWidth: "100%",
												}}
											/>
										</Card>
									</Grid>
									<Grid item xs={12}>
										<Card
											header={{
												hardTitle: "Categoria",
											}}
											style={{
												width: "100%",
												minHeight: "250px",
												height: "30vh",
											}}
										>
											<NativeObject
												app={app}
												key="FANf"
												reference={{ id: "FANf" }}
											/>
										</Card>
									</Grid>
								</Grid>
							</LayoutCardWrapper>
						</Grid>
						<Grid item xs={12}>
							<LayoutCardWrapper>
								<Grid
									container
									direction="column"
									justifyContent={"flex-start"}
									alignItems={"center"}
									style={{
										width: "100%",
										display: "flex",
										marginRight: "12px",
									}}
								>
									<Grid item xs={12}>
										<Card
											header={{
												hardTitle: "Evolução",
												legends: [
													{
														type: "bar",
														iconColor: "#F98561",
														name: "Meta",
													},
													{
														type: "bar",
														iconColor: "#55B6EB",
														name: "Realizado",
													},
												],
												scale: false,
											}}
											style={{
												width: "100%",
												minHeight: "240px",
												height: "100%",
											}}
											classStyle={"row-header"}
										>
											<NativeObject
												app={app}
												key="PnTUv"
												reference={{ id: "PnTUv" }}
												type="table"
												style={{
													width: "100%",
													height: "100%",
													overflow: "auto",
												}}
											/>
										</Card>
									</Grid>
								</Grid>
							</LayoutCardWrapper>
						</Grid>
					</Grid>
				</LayoutCardsWrapper>
			</div>
		</div>
	);
}

OverviewMobile.defaultProps = {
	app: null,
	config: {},
};

OverviewMobile.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default OverviewMobile;
